var advancedEditor = {
    menubar: 'edit insert view format table tools help',
    plugins: 'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern help',
    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor formatpainter | link image pageembed | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | addcomment',
    min_height: 300,
    branding: false
}

var basicEditor = {
    forced_root_block: false,
    plugins: 'autolink lists link anchor paste',
    menubar: false,
    toolbar: 'bold italic underline bullist numlist | link | undo redo | removeformat',
    entity_encoding: 'raw',
    add_unload_trigger: false,
    remove_linebreaks: true,
    inline_styles: false,
    convert_fonts_to_spans: false,
    target_list: false,
    link_title: false,
    convert_urls: false,
    force_p_newlines: false,
    branding: false
}

function applyTinyMCE(selector, settings)
{
    tinymce.init(Object.assign(settings, {
        selector: selector,
        setup: (editor) => {
            editor.on('change', () => {
                tinymce.triggerSave();
            })
        }
    }));
}

if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', pageLoaded);
} else {
    pageLoaded();
}


function pageLoaded() {
    applyTinyMCE('#precedent_info_', advancedEditor);
    applyTinyMCE('#precedent_info_0', advancedEditor);
    applyTinyMCE('#content-as-html', basicEditor)
}

function applyToNewTextarea(index)
{
    applyTinyMCE('#precedent_info_' + index, advancedEditor);

    // in case it doesn't apply, try again in 5 seconds
    setTimeout(function () {
        applyTinyMCE('#precedent_info_' + index, advancedEditor);
    }, 5000);
}
